import { gql } from "@apollo/client";

export const GET_CITIZEN_MENU = gql`
  query citizenJoyPrograms($limit: Int, $sort: String) {
    citizenJoyPrograms(limit: $limit, sort: $sort) {
      id
      title
      description
      feat_img {
        url
      }
      citizen_joy_images {
        id
        title
        image_description
        images {
          url
        }
        feat_img {
          id
          url
        }
      }
      citizen_joy_videos {
        id
        title
        video_url
        created_date
      }
      citizen_joy_files {
        id
        title
        file {
          id
          name
          mime
          url
        }
      }
    }
  }
`;

// export const GET_CITIZEN_PROGRAM = gql`
//   query citizenJoyProgram($id: ID!) {
//     citizenJoyProgram(id: $id) {
//       id
//       title
//       description
//       feat_img {
//         url
//       }
//       citizen_joy_images {
//         id
//         title
//         feat_img {
//           id
//           url
//         }
//         image_description
//         images {
//           url
//         }
//       }
//       citizen_joy_videos {
//         id
//         title
//         video_url
//         created_date
//       }
//       citizen_joy_files {
//         id
//         title
//         file {
//           id
//           name
//           mime
//           url
//         }
//       }
//     }
//   }
// `;

export const GET_CITIZEN_PROGRAM = gql`
  query citizenJoyProgram($id: ID!) {
    citizenJoyProgram(id: $id) {
      id
      title
      description
      feat_img {
        url
      }

      citizen_joy_videos {
        id
        title
        video_url
        created_date
      }
      citizen_joy_files {
        id
        title
        file {
          id
          name
          mime
          url
        }
      }
    }
  }
`;

export const GET_CITIZEN_IMAGES_BY_ID = gql`
  query citizenJoyImages($limit: Int, $sort: String,$where: JSON,$start:Int) {
    citizenJoyImages(limit: $limit, sort: $sort, where: $where,start:$start) {
      id
      title
      feat_img {
        id
        url
      }
      image_description
      created_date
      images {
         url
        }
    }
  }
`;



export const GET_CITIZEN_IMAGES = gql`
  query citizenJoyImages($limit: Int, $sort: String) {
    citizenJoyImages(limit: $limit, sort: $sort) {
      id
      title
      feat_img {
        id
        url
      }
      created_date
      citizen_joy_program {
        id
        title
      }
    }
  }
`;
